import { createFileRoute } from '@tanstack/react-router';
import { PageContent } from '@/components/page-content';
import { VisitorIdRegionSettings } from '@/components/visitor-id/region-settings';

export const Route = createFileRoute(
  '/_auth/_side-layout/super-admin/visitor-id/regions',
)({
  component: () => (
    <PageContent>
      <VisitorIdRegionSettings />
    </PageContent>
  ),
});
